const getUser = state => {
  return state.user.user;
};

const userSelectors = {
  getUser
};

export default userSelectors;
